import request from '@/utils/request'

export default {
    helpRegister: function (query) {
        return request({
            url: 'helpRegister/helpRegister',
            method: 'post',
            params: {
                traderId: query.traderId,
            }
        });
    },
}